import React, { useState } from "react";
import {
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import MainBody from "./MainBody";
import guidanceEmigratingUKObj from "./content/emigrating-uk.json";

function EmigratingUK() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [chapter] = useState("");

  return (
    <>
      <Container className={classes.container}>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Typography className={classes.title}>
              {t("Travelling to the UK from Hong Kong – passports and visas")}
            </Typography>
            <Grid container spacing={5}>
              <Grid
                item
                sm={12}
                md={6}
                dangerouslySetInnerHTML={{
                  __html: t(
                    "The permissions you need to travel to the UK depend on your passport and the purpose of your travel."
                  ),
                }}
              />
              <Grid item sm={12} md={6}>
                <ul className={classes.list}>
                  <li>
                    {t(
                      "People’s Republic of China passport: You need to obtain a visa before travelling to the UK for any purpose."
                    )}
                  </li>
                  <li>
                    {t(
                      "Hong Kong passport: You can enter the UK without a visa as a visitor. You need to apply for other visas, such as student or work, in Hong Kong before travelling to the UK."
                    )}
                  </li>
                  <li>
                    {t(
                      "British National (Overseas) passport: You can enter the UK without a visa as a visitor. You need to apply for other visas, such as student or work, in Hong Kong before travelling to the UK."
                    )}
                  </li>
                </ul>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <MainBody GodObj={guidanceEmigratingUKObj} changeChapter={chapter} />
      </Container>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  list: {
    margin: "0px",
    "& li:not(:last-child)": {
      marginBottom: "20px",
    },
  },
  cardContent: {
    padding: "0 !important",
    "& a": {
      color: "white",
    },
  },
  card: {
    border: `1px solid ${guidanceEmigratingUKObj.colorTheme.mainColor}`,
    backgroundColor: "transparent",
    marginTop: "40px",
    padding: "60px 100px",
    boxShadow: "none",
    fontFamily: "Manrope",
    whiteSpace: "pre-line",
    [theme.breakpoints.down("sm")]: {
      padding: "40px 20px",
      marginBottom: "60px",
    },
  },
  title: {
    fontSize: "22px",
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: "32px",
    [theme.breakpoints.down("sm")]: {
      // fontSize: '24px'
    },
  },
  container: {
    marginTop: "100px",
    fontSize: "16px",
    lineHeight: 1.5,
    [theme.breakpoints.down("xs")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0px",
      fontSize: "15px",
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "1408px",
    },
  },
}));

export default EmigratingUK;
